import React from 'react';
import DefaultTable from 'components/atoms/tables/smarttables/DefaultTable';
import { generateHeaders, applyDefaultColumns } from 'helpers/tables';
import helpers from 'helpers';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import ContentTile from 'components/atoms/layout/ContentTile';
import { Label } from 'react-bootstrap';

const SitesSummaryTable = ({ data, cacheKey }) => {
    const accessors = ['publisherLogo', 'publisher', 'app_name', 'impressions', 'started_plays', 'completed_plays', 'completion_rate'];
    const defaultCols = ['publisherLogo', 'publisher', 'app_name', 'impressions', 'completion_rate'];
    const headers = generateHeaders({ keys: accessors });
    const columns = applyDefaultColumns(accessors.map(accessor => headers[accessor]), defaultCols);

    const mappedData = data.map(row => (
        {
            ...row,
            publisher: row.publisher && row.publisher.trim(),
            publisherLogo: {
                image: row.publisherLogo
            }
        })
    );

    const toggle = mappedData.some(row => row.publisher === 'Other') && {
        initialFilter: true,
        label: 'Hide Unknown'
    };

    return (
        <ContentTile padding={helpers.contentPadding('table')}>
            <ContentHeader type={'table'} allowExport={false}>
                Publishers
                <Label bsStyle="primary" style={{ marginLeft: '5px', verticalAlign: 'middle' }}>Beta</Label>
            </ContentHeader>
            {mappedData &&
                <DefaultTable
                    cacheKey={cacheKey}
                    columns={columns}
                    data={mappedData}
                    globalSearch={false}
                    exportData
                    title={'Publishers'}
                    aggregate={true}
                    dataToggle={toggle}
                    defaultState={{
                        sortBy: [
                            {
                                id: 'impressions',
                                desc: true
                            }
                        ]
                    }}
                />
            }
        </ContentTile>
    );
};

SitesSummaryTable.propTypes = {};

export default SitesSummaryTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/SitesSummaryTable.js